import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-tpams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationLocationTpamsConstants } from "./create-application-location-tpams.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import Query from "@arcgis/core/rest/support/Query";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapService } from "../../../../map/shared/map.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiModuleConstants } from "../../../../shared/constants/api-constants/api-module.constants";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { MapTools } from "../../../../map/shared/map.tools";
import { debounceTime } from "rxjs";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { MapServiceConstants } from "../../../../shared/constants/map-service.constants";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { CreateApplicationLocationEcConstants } from "../../ec/create-application-location-ec/create-application-location-ec.constants";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { AppConfig } from "../../../../app.config";
import { UserInformationService } from "../../../../shared/services/user/user-information.service";
let CreateApplicationLocationTpamsComponent = class CreateApplicationLocationTpamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    mapTools;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    userInformationService;
    searchApplicationsService;
    active;
    propertiesForm;
    showPropertyForm = false;
    descriptionLabel1 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationTpamsConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationTpamsConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationTpamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationTpamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationTpamsConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationTpamsConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationTpamsConstants.ADDRESS_CONTROL;
    buildingUseControl = CreateApplicationLocationTpamsConstants.BUILDING_USE_CONTROL;
    erfSizeControl = CreateApplicationLocationTpamsConstants.ERF_SIZE_CONTROL;
    buildingFloorAreaControl = CreateApplicationLocationTpamsConstants.BUILDING_FLOOR_AREA_CONTROL;
    titleDeedControl = CreateApplicationLocationTpamsConstants.TITLE_DEED_CONTROL;
    zoneControl = CreateApplicationLocationTpamsConstants.ZONE_CONTROL;
    ownerControl = CreateApplicationLocationTpamsConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationTpamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationTpamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationTpamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationTpamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationTpamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationTpamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    buildingUseTextPlaceHolder = CreateApplicationLocationTpamsConstants.BUILDING_USE_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationTpamsConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    buildingFloorAreaTextPlaceHolder = CreateApplicationLocationTpamsConstants.BUILDING_FLOOR_AREA_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = CreateApplicationLocationTpamsConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    zoneLabel = CreateApplicationLocationTpamsConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = CreateApplicationLocationTpamsConstants.ADD_ZONE_LABEL;
    removePropertyLabel = CreateApplicationLocationTpamsConstants.REMOVE_PROPERTY_LABEL;
    copyOwnerLabel = CreateApplicationLocationTpamsConstants.COPY_OWNER_LABEL;
    ownerLabel = CreateApplicationLocationTpamsConstants.OWNER_LABEL;
    layerReference = CreateApplicationLocationTpamsConstants.LAYER_REF;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    zones = [];
    fullApplicationCheckRequired = true;
    showOnlyPropertyAndZoningLayers = false;
    missingZoneList = new Map();
    applicantGroups = [];
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    mapComponent;
    isMapLoaded = false;
    hasLoadedApplicationProperties = false;
    missingZoneTuple;
    resubmissionForm;
    verificationMessage = CreateApplicationLocationTpamsConstants.RESUBMISSION_VERIFICATION_MESSAGE;
    acceptVerificationMessage = CreateApplicationLocationTpamsConstants.ACCEPT_RESUBMISSION_VERIFICATION_MESSAGE;
    verificationMessageFailure = CreateApplicationLocationTpamsConstants.RESUBMISSION_VERIFICATION_MESSAGE_FAILURE;
    resubmissionMessage = CreateApplicationLocationTpamsConstants.RESUBMISSION_MESSAGE;
    previousReferenceNumberLabel = CreateApplicationLocationTpamsConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = CreateApplicationLocationTpamsConstants.IS_RESUBMISSION_LABEL;
    verifyLabel = CreateApplicationLocationTpamsConstants.VERIFY_LABEL;
    previousReferenceNumberFormControlName = CreateApplicationLocationTpamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isResubmissionFormControlName = CreateApplicationLocationTpamsConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    supportResubmissions = false;
    isResubmission = false;
    isVerified = false;
    isResubmissionOptions = [];
    currentUser = null;
    acceptDisclaimerForm;
    acceptFormControlName = CreateApplicationLocationTpamsConstants.ACCEPT_FORM_CONTROL_NAME;
    resubmissionDisclaimerTitle = "";
    resubmissionDisclaimerContent = "";
    acceptFormControlLabel = CreateApplicationLocationTpamsConstants.ACCEPT_LABEL;
    titleLabelMessage = CreateApplicationLocationTpamsConstants.RESUBMISSION_DISCLAIMER_TITLE_LABEL_MESSAGE;
    contentLabelMessage = CreateApplicationLocationTpamsConstants.RESUBMISSION_DISCLAIMER_CONTENT_LABEL_MESSAGE;
    acceptResubmissionDisclaimer = false;
    selectedPropertySubscription;
    sendMissingLookupsEmailSubscription;
    selectedApplicatioLocationTpamsSubscription;
    clearLayerGraphicsSubjectSubscription;
    previousApplicationSubscription;
    currentUserSubscription;
    getTrueCentroidSubscription;
    constructor(applicationCreateService, mapTools, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, changeDetectorRefs, userInformationService, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.mapTools = mapTools;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.userInformationService = userInformationService;
        this.searchApplicationsService = searchApplicationsService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.resubmissionDisclaimerTitle = AppConfig.settings.resubmissionDisclaimer.tp.title;
            this.resubmissionDisclaimerContent = AppConfig.settings.resubmissionDisclaimer.tp.content;
            if (this.resubmissionDisclaimerTitle === "") {
                this.resubmissionDisclaimerTitle = this.titleLabelMessage;
            }
            if (this.resubmissionDisclaimerContent === "") {
                this.resubmissionDisclaimerContent = this.contentLabelMessage;
            }
        }
    }
    get getProperties() {
        return this.propertiesForm.get("properties");
    }
    ngOnInit() {
        this.checkAndInitialiseLookups();
        this.initForm();
        this.getMetadata();
        this.subscribeToProperty();
        this.setupSubscribers();
        this.currentUserSubscription = this.userInformationService.$authenticatedUser.subscribe({
            next: (user) => {
                this.currentUser = user;
            }
        });
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
        }
        if (this.supportResubmissions) {
            this.showPropertyForm = false;
        }
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.destroyMap();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.applicantGroups = stepMeta.applicantGroup;
        this.changeDetectorRefs.markForCheck();
    }
    getZones(propertyIndex) {
        return this.getProperties.controls[propertyIndex].get("zones");
    }
    onBtnRemoveZoneClicked(propertyIndex, zoneIndex) {
        const controls = this.getZones(propertyIndex);
        if (controls.controls.length > 1) {
            controls.removeAt(zoneIndex);
        }
    }
    onBtnAddZoneClicked(propertyIndex) {
        const zonesControl = this.getZones(propertyIndex);
        const zoneGroup = new FormGroup({
            zone: new FormControl(null, [Validators.required])
        });
        zonesControl.push(zoneGroup);
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        const previousActiveIndex = this.active;
        this.getProperties.removeAt(propertyIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
        if (previousActiveIndex === propertyIndex && propertyIndex > 0) {
            this.active = propertyIndex - 1;
        }
        else if (previousActiveIndex > propertyIndex) {
            this.active = previousActiveIndex - 1;
        }
    }
    getMissingZones(index) {
        if (this.missingZoneList && this.missingZoneList.size > 0) {
            // send email to module admin if it has not already been sent
            this.missingZoneTuple = this.missingZoneList.get(index);
            if (this.missingZoneTuple[1] === false) {
                this.missingZoneTuple = [this.missingZoneTuple[0], true];
                this.missingZoneList.set(index, this.missingZoneTuple);
            }
            let zones = "";
            let count = 1;
            this.missingZoneTuple[0].forEach((zone) => {
                zones += zone + (count < zone.length ? "|" : "");
                count++;
            });
            return `${CreateApplicationLocationTpamsConstants.MISSING_ZONE_LABEL} ${zones} ${CreateApplicationLocationTpamsConstants.MISSING_ZONE_LABEL_EMAIL}`;
        }
    }
    updatePropertyRequiredFields(newProperty) {
        const erfNoControl = newProperty.get(this.erfNoControl);
        const farmNoControl = newProperty.get(this.farmNoControl);
        const subdivisionControl = newProperty.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = false;
            this.farmNoControlRequired = false;
            this.erfNoControlRequired = true;
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = false;
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = true;
        }
        const sgCodeControl = newProperty.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    setNumberToDecimal(formControl, event) {
        // sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        formControl.setValue(decimalValue);
    }
    initForm() {
        this.resubmissionForm = new FormGroup({
            isResubmission: new FormControl(null, [Validators.required]),
            previousReferenceNumber: new FormControl(null)
        });
        this.acceptDisclaimerForm = new FormGroup({
            acceptControl: new FormControl(null),
        });
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.getProperties.controls.forEach(control => {
            control.get(this.erfSizeControl).setValidators([Validators.required]);
            control.get(this.erfSizeControl).updateValueAndValidity();
        });
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and name eq 'Zoning'`,
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (lookupResponse) => this.onGetLookupsCompleted(lookupResponse),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zones", zones);
        this.zones = zones;
        this.sortZones();
        this.applicationCreateService.setHasLoadedLookups(true);
        this.isResubmissionOptions = [{
                code: SharedConstants.YES_NO_ENUM.Yes,
                value: SharedConstants.YES_NO_ENUM.Yes
            }, { code: SharedConstants.YES_NO_ENUM.No, value: SharedConstants.YES_NO_ENUM.No }];
        this.changeDetectorRefs.detectChanges();
    }
    setPropertyAttributes(propertyAttributes, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyData");
        try {
            this.showPropertyForm = true;
            const sgCode = CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "SgCode", "sgcode");
            const duplicateFound = CreateApplicationUtils.checkIfPropertyIsADuplicate(sgCode, this.getProperties, this.appController, this.requestStatusService);
            if (!duplicateFound) {
                const newPropertyFormGroup = CreateApplicationUtils.createNewPropertyFormGroup(propertyAttributes, sgCode, geometry);
                this.applicationCreateService.getPropertyCentroidObservable(geometry).subscribe({
                    next: (trueCentroidResponse) => {
                        CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, newPropertyFormGroup);
                        this.queryZoningLayer(sgCode, newPropertyFormGroup);
                    },
                    error: (error) => {
                        this.requestStatusService.removeBusySpinner("GetPropertyDate");
                        this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            }
        }
        catch (e) {
            this.appController.handleServerErrorMessage("getTrueCentroid", e, CRUDOperation.Get);
            this.requestStatusService.showBusySpinner("GetPropertyData");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties.controls.forEach(propertyControl => {
            const geom = propertyControl.get("geometry").value;
            if (geom) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Town planning graphics", true);
        }
        else {
            this.mapComponent.removeGraphicsFromMap("Town planning graphics");
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(propertyData => {
            if (propertyData !== null) {
                this.setPropertyAttributes(propertyData.attributes, propertyData.geometry);
            }
        });
    }
    sendEmailMissingLookupForZones(missingLookupsForZones) {
        const url = `${ApiModuleConstants.URL}/${ApiModuleConstants.MISSING_LOOKUP_EMAIL_REQUEST_URL}`;
        const params = {
            moduleId: this.applicationCreateService.moduleID, lookupType: "Zoning", lookupList: missingLookupsForZones
        };
        this.sendMissingLookupsEmailSubscription = this.applicationCreateService.sendMissingLookupsEmail(url, params)
            .subscribe({
            next: () => {
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(`${CreateApplicationLocationTpamsConstants.MISSING_ZONE_LABEL_EMAIL_FAILED}`, error, CRUDOperation.Selecting);
            }
        });
    }
    subscribeToClearGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.showPropertyForm = false;
                    this.getProperties.clear();
                    this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    sortZones() {
        // sort zones dropdown alphabetically
        this.zones?.sort((a, b) => (a.value?.localeCompare(b?.value)));
    }
    queryZoningLayer(sgCode, newPropertyFormGroup) {
        const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === MapServiceConstants.PROPERTY_ZONING_LAYER);
        if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
            const zoningLayer = zoningLayerObj.layer;
            const zoningQuery = new Query();
            zoningQuery.where = `SgCode = '${sgCode}'`;
            zoningQuery.returnGeometry = false;
            zoningQuery.outFields = ["*"];
            zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                this.handleResponseAfterQueryingPropertyZoningFeatures(newPropertyFormGroup, zoneFeatureSet);
                this.setPropertyTabs(newPropertyFormGroup);
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (zoningError) => {
                this.appController.showMessage(zoningError.message, AlertType.Error);
                this.setPropertyTabs(newPropertyFormGroup);
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            });
            this.updatePropertyRequiredFields(newPropertyFormGroup);
            this.showPropertyForm = true;
            this.sortZones();
        }
        else {
            const zonesControl = newPropertyFormGroup.get("zones");
            zonesControl.push(new FormGroup({
                zone: new FormControl(null, [Validators.required])
            }));
            this.updatePropertyRequiredFields(newPropertyFormGroup);
            this.showPropertyForm = true;
            this.setPropertyTabs(newPropertyFormGroup);
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    handleResponseAfterQueryingPropertyZoningFeatures(newPropertyFormGroup, zoneFeatureSet) {
        const zonesControl = newPropertyFormGroup.get("zones");
        if (zoneFeatureSet.features.length > 0) {
            zoneFeatureSet.features.forEach(item => {
                const zone = CreateApplicationUtils.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning");
                if (zone !== undefined && zone != null) {
                    let foundZone = null;
                    this.zones.forEach(zoneItem => {
                        if (zoneItem.value === zone) {
                            foundZone = zoneItem;
                        }
                    });
                    if (foundZone !== null) {
                        zonesControl.push(new FormGroup({
                            zone: new FormControl(foundZone, [Validators.required])
                        }));
                    }
                    else {
                        this.appController.showMessage(CreateApplicationLocationTpamsConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Warning);
                        this.sendEmailMissingLookupForZones([zone]);
                    }
                }
                else {
                    this.appController.showMessage(CreateApplicationLocationTpamsConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                }
            });
        }
        if (zonesControl.length === 0) {
            zonesControl.push(new FormGroup({
                zone: new FormControl(null, [Validators.required])
            }));
        }
    }
    setPropertyTabs(newPropertyFormGroup) {
        const propertyControl = this.getProperties;
        propertyControl.push(newPropertyFormGroup);
        this.active = propertyControl.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicatioLocationTpamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
            if (this.selectedApplication) {
                this.updateComponentData();
            }
        });
    }
    setupSubscribers() {
        this.subscribeToClearGraphics();
        this.subscribeToSelectedApplication();
    }
    updateComponentData() {
        if (+this.jobId > 0 && this.selectedApplication) {
            const propertyControl = this.clearPropertyData();
            let tabIndex = 0;
            this.selectedApplication.properties.sort((a, b) => (b?.id - a?.id));
            this.selectedApplication.properties.forEach(savedProperty => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(savedProperty.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newPropertyFormGroup = CreateApplicationUtils.getUpdatedPropertyFormGroup(savedProperty, geom);
                this.propertiesForm.markAllAsTouched();
                this.updateZoneDropdown(newPropertyFormGroup, savedProperty, tabIndex);
                this.applicationCreateService.getPropertyCentroidObservable(geom).subscribe({
                    next: (trueCentroidResponse) => {
                        CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, newPropertyFormGroup);
                        propertyControl.push(newPropertyFormGroup);
                        this.active = propertyControl.length - 1;
                        this.syncMapGeometries();
                        CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                        this.updatePropertyRequiredFields(newPropertyFormGroup);
                        this.showPropertyForm = true;
                        this.changeDetectorRefs.detectChanges();
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
                tabIndex++;
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.hasLoadedApplicationProperties = true;
            this.changeDetectorRefs.detectChanges();
            if (this.selectedApplication.isResubmission) {
                this.resubmissionForm.get("isResubmission").setValue("Yes");
                this.resubmissionForm.get("previousReferenceNumber").setValue(this.selectedApplication.previousReferenceNumber);
            }
            else {
                this.resubmissionForm.get("isResubmission").setValue("No");
            }
        }
    }
    clearPropertyData() {
        this.missingZoneList = new Map();
        this.applicationCreateService.$missingLookupsForZones = [];
        const propertyControl = this.getProperties;
        propertyControl.clear();
        this.showPropertyForm = false;
        return propertyControl;
    }
    updateZoneDropdown(newPropertyFormGroup, savedProperty, tabIndex) {
        const missingLookupsForZones = [];
        const zonesControl = newPropertyFormGroup.get("zones");
        savedProperty.zonings.forEach(zone => {
            let foundZone = false;
            this.zones.forEach(zoneOption => {
                if (zoneOption.value === zone.zoning) {
                    foundZone = true;
                    const zoneGroup = new FormGroup({
                        id: new FormControl(zone.id),
                        applicationId: new FormControl(zone.applicationId),
                        applicationPropertyId: new FormControl(zone.applicationPropertyId),
                        zone: new FormControl(zoneOption, [Validators.required]),
                        deleted: new FormControl(zone.deleted)
                    });
                    zonesControl.push(zoneGroup);
                }
            });
            this.zones?.sort((a, b) => (a.value?.localeCompare(b?.value)));
            if (!foundZone) {
                missingLookupsForZones.push(zone.zoning);
                this.applicationCreateService.$missingLookupsForZones.push(zone.zoning);
            }
        });
        if (missingLookupsForZones.length > 0) {
            this.missingZoneTuple = [missingLookupsForZones, false];
            this.missingZoneList.set(tabIndex, this.missingZoneTuple);
        }
    }
    checkAndInitialiseLookups() {
        this.hasLoadedApplicationProperties = false;
        this.applicationCreateService.setHasLoadedLookups(false);
        this.selectedApplicationService.$applicationSavedSubject.next(false);
        if (this.aflaModuleStrategyService.lookups.has("zones")) {
            this.zones = this.aflaModuleStrategyService.lookups.get("zones");
            this.sortZones();
            this.applicationCreateService.setHasLoadedLookups(true);
        }
        else {
            this.getLookups();
        }
    }
    onCopyOwnerToApplicant(propertyIndex) {
        const ownersControl = this.getProperties.controls[propertyIndex].get(this.ownerControl);
        const selectedOwners = ownersControl.value ? ownersControl.value.filter((x) => x.selected === true) : [];
        if (selectedOwners.length === 0) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.NO_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length > 1) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.MULTIPLE_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length === 1) {
            const applicant = RecipientUtils.buildApplicantStringForUserSettings(selectedOwners[0], this.applicantGroups);
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(applicant);
            this.appController.showMessage("Owner data successfully copied", AlertType.Success);
        }
    }
    onToggleAccept(event) {
        if (this.aflaModuleStrategyService.previousApplication !== null) {
            const accept = event.target.checked;
            this.acceptResubmissionDisclaimer = accept;
            this.aflaModuleStrategyService.previousApplication.acceptResubmissionDisclaimer = accept;
        }
        else {
            this.appController.showMessage(this.acceptVerificationMessage, AlertType.Success);
            this.acceptDisclaimerForm.get(this.acceptFormControlName).setValue(false);
            this.acceptResubmissionDisclaimer = false;
            return;
        }
    }
    onIsResubmissionChanged(event) {
        const element = event.target?.value;
        this.aflaModuleStrategyService.previousApplication = null;
        this.acceptResubmissionDisclaimer = null;
        this.resetVerification();
        this.aflaModuleStrategyService.resetForm();
        this.aflaModuleStrategyService.form.get("propertiesForm").get("properties").clear();
        if (element === SharedConstants.YES_NO_ENUM.Yes) {
            this.resubmissionForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).enable();
            this.acceptDisclaimerForm.get("acceptControl").setValidators([Validators.required]);
            this.acceptDisclaimerForm.get("acceptControl").setValue(null);
            this.isResubmission = true;
            this.isVerified = false;
            this.showPropertyForm = false;
            this.acceptResubmissionDisclaimer = false;
        }
        else {
            this.resubmissionForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).disable();
            this.acceptDisclaimerForm.get("acceptControl").clearValidators();
            this.acceptDisclaimerForm.get("acceptControl").setValue(null);
            this.isResubmission = false;
            this.isVerified = false;
            this.showPropertyForm = true;
            this.acceptResubmissionDisclaimer = false;
        }
        this.acceptDisclaimerForm.get("acceptControl").updateValueAndValidity();
        this.resubmissionForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
        this.resubmissionForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    resetVerification() {
        this.aflaModuleStrategyService.previousApplication = null;
        this.isVerified = false;
        this.showPropertyForm = false;
        this.changeDetectorRefs.detectChanges();
        const propertyControl = this.getProperties;
        this.missingZoneList = new Map();
        this.applicationCreateService.$missingLookupsForZones = [];
        propertyControl.clear();
        this.aflaModuleStrategyService.form.get("propertiesForm").get("properties").clear();
        this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
        this.propertiesForm.reset();
        this.aflaModuleStrategyService.form.reset();
        this.aflaModuleStrategyService.form.get("detailsForm").reset();
        this.aflaModuleStrategyService.form.get("applicantForm").reset();
        this.aflaModuleStrategyService.form.get("applicantAgentForm").reset();
    }
    onVerifyReferenceNumberClicked() {
        this.resetVerification();
        const previousReferenceNumber = this.resubmissionForm.get(this.previousReferenceNumberFormControlName).value;
        if (this.resubmissionForm.invalid) {
            this.resubmissionForm.updateValueAndValidity();
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).markAsTouched();
            this.changeDetectorRefs.detectChanges();
            return;
        }
        if (previousReferenceNumber !== null || previousReferenceNumber !== "") {
            const params = {
                previousReferenceNumber: previousReferenceNumber,
                isResubmission: this.isResubmission,
                moduleId: this.appController.selectedModuleID
            };
            this.aflaModuleStrategyService.verifyResubmissionReferenceNumberObservable(params).subscribe({
                next: data => {
                    this.onVerifySuccess(data);
                },
                error: err => {
                    this.onVerifyFailure(err);
                }
            });
        }
    }
    onVerifySuccess(data) {
        if (data !== null) {
            this.showPropertyForm = true;
            this.isVerified = true;
            this.aflaModuleStrategyService.previousApplication = data;
            this.getVerifiedApplication();
            this.appController.showMessage(this.verificationMessage, AlertType.Success);
        }
        else {
            this.appController.showMessage(this.verificationMessageFailure, AlertType.Warning);
            this.isVerified = false;
            this.showPropertyForm = false;
            this.changeDetectorRefs.detectChanges();
        }
    }
    onVerifyFailure(err) {
        if (this.isString(err.error)) {
            this.appController.showMessage(err.error, AlertType.Warning);
        }
        else {
            this.appController.handleServerErrorMessage("verify resubmission", err, CRUDOperation.Get);
        }
        this.isVerified = false;
        this.showPropertyForm = false;
        this.changeDetectorRefs.detectChanges();
    }
    isString(value) {
        return typeof value === "string";
    }
    getVerifiedApplication() {
        const params = {
            $filter: `jobId eq ${this.aflaModuleStrategyService.previousApplication.jobId} and moduleId eq ${this.appController.selectedModuleID}`,
            $expand: `properties($expand=zonings,owners($expand=groups)),applicant($expand=groups),applicantAgent($expand=groups),applicationTypes,applicationZonings`
        };
        this.previousApplicationSubscription = this.aflaModuleStrategyService.getAllApplicationsQuery(params).pipe(debounceTime(1000)).subscribe((returnValue) => {
            const cleanedResult = this.cleanPreviousApplicationData(returnValue.value[0]);
            const result = cleanedResult;
            this.aflaModuleStrategyService.previousApplication = result;
            this.selectedApplication = result;
            const propertyControl = this.clearPropertyData();
            let tabIndex = 0;
            this.selectedApplication.properties.sort((a, b) => (b?.id - a?.id));
            this.selectedApplication.properties.forEach(savedProperty => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(savedProperty.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newPropertyFormGroup = CreateApplicationUtils.getUpdatedPropertyFormGroup(savedProperty, geom);
                this.propertiesForm.markAllAsTouched();
                this.updateZoneDropdown(newPropertyFormGroup, savedProperty, tabIndex);
                this.applicationCreateService.getPropertyCentroidObservable(geom).subscribe({
                    next: (trueCentroidResponse) => {
                        CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, newPropertyFormGroup);
                        propertyControl.push(newPropertyFormGroup);
                        this.active = propertyControl.length - 1;
                        this.syncMapGeometries();
                        CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                        this.updatePropertyRequiredFields(newPropertyFormGroup);
                        this.showPropertyForm = true;
                        this.changeDetectorRefs.detectChanges();
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
                tabIndex++;
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.hasLoadedApplicationProperties = true;
            this.changeDetectorRefs.detectChanges();
        });
    }
    cleanPreviousApplicationData(application) {
        const app = {};
        if (application) {
            app.applicantAgentNa = application.applicantAgentNa;
            app.decision = application.decision;
            app.applicantAgentNa = application.applicantAgentNa;
            app.description = application.description;
            app.shape = application.shape;
            app.wkid = application.wkid;
            app.moduleId = application.moduleId;
            app.amendmentSchemeNumber = application.amendmentSchemeNumber;
            app.decision = application.decision;
            app.townplannerId = application.townplannerId;
            app.shape = application.shape;
            app.wkid = application.wkid;
            app.applicationTypes = application.applicationTypes,
                app.applicationZonings = application.applicationZonings,
                app.daysUntilExpired = application.daysUntilExpired,
                app.townplannerId = application.townplannerId;
        }
        if (application.applicationTypes) {
            let applicationTypes = {};
            applicationTypes = [];
            application.applicationTypes.forEach(a => {
                const applicationType = {};
                applicationType.applicationType = a.applicationType;
                applicationTypes.push(applicationType);
            });
            app.applicationTypes = applicationTypes;
        }
        if (application.applicationZonings) {
            let zonings = {};
            zonings = [];
            application.applicationZonings.forEach(z => {
                const zone = {};
                zone.zoning = z.zoning;
                zonings.push(zone);
            });
            app.applicationZonings = zonings;
        }
        if (this.resubmissionForm.get("isResubmission").value === SharedConstants.YES_NO_ENUM.Yes) {
            app.isResubmission = true;
        }
        else {
            app.isResubmission = false;
        }
        if (app.isResubmission) {
            app.previousReferenceNumber = this.resubmissionForm.get("previousReferenceNumber").value ?? null;
        }
        if (application.properties) {
            let properties = {};
            properties = [];
            application.properties.forEach(p => {
                const property = {};
                property.id = 0;
                property.erfNumber = p.erfNumber;
                property.allotment = p.allotment;
                property.farmNumber = p.farmNumber;
                property.sgCode = p.sgCode;
                property.address = p.address;
                property.erfSize = p.erfSize;
                property.titleDeed = p.titleDeed;
                property.subdivision = p.subdivision;
                property.shape = p.shape;
                property.wkid = p.wkid;
                property.isDummy = p.isDummy;
                property.updateGeometry = p.updateGeometry;
                property.buildingFloorArea = p.buildingFloorArea;
                property.updateGeometry = p.updateGeometry;
                property.buildingUse = p.buildingUse;
                if (this.currentUser.id === application.createdUserId) {
                    if (p.owners) {
                        let owners = {};
                        owners = [];
                        p.owners.forEach(o => {
                            const owner = {};
                            owner.clientVatNumber = o.clientVatNumber;
                            owner.setRecipient = o.setRecipient;
                            owner.fullName = o.fullName;
                            owner.id = 0;
                            owner.moduleId = o.moduleId;
                            owner.name = o.name;
                            owner.surname = o.surname;
                            owner.telephone = o.telephone;
                            owner.email = o.email;
                            owner.defaultCommunicationMethod = o.defaultCommunicationMethod;
                            owner.postalAddress = o.postalAddress;
                            owner.designation = o.designation;
                            owner.organisation = o.organisation;
                            owner.streetAddress = o.streetAddress;
                            owner.homePhone = o.homePhone;
                            owner.idNumber = o.idNumber;
                            owner.organisationRegistrationNumber = o.organisationRegistrationNumber;
                            owner.representative = o.representative;
                            owner.fax = o.fax;
                            owner.maritalStatus = o.maritalStatus;
                            owner.relativesFullName = o.relativesFullName;
                            owner.relativesContactNumber = o.relativesContactNumber;
                            owner.relativesAddress = o.relativesAddress;
                            owner.employmentStatus = o.employmentStatus;
                            owner.employersName = o.employersName;
                            owner.employersContactNumber = o.employersContactNumber;
                            owner.employersAddress = o.employersAddress;
                            owner.cellphone = o.cellphone;
                            owner.streetSuburb = o.streetSuburb;
                            owner.streetCity = o.streetCity;
                            owner.streetProvince = o.streetProvince;
                            owner.streetCode = o.streetCode;
                            owner.postalSuburb = o.postalSuburb;
                            owner.postalCity = o.postalCity;
                            owner.postalProvince = o.postalProvince;
                            owner.postalCode = o.postalCode;
                            owner.postalCountry = o.postalCountry;
                            owner.streetCountry = o.streetCountry;
                            owner.professionalBody = o.professionalBody;
                            owner.professionalBodyRegNum = o.professionalBodyRegNum;
                            owner.consolidatedGroup = o.consolidatedGroup;
                            owner.emailField = o.emailField;
                            let groups = {};
                            groups = [];
                            o.groups.forEach(g => {
                                const group = {};
                                group.groupName = g.groupName;
                                group.groupType = g.groupType;
                                groups.push(group);
                            });
                            owner.groups = groups;
                            /*     owner.groupsStringArray?: string[]; */
                            owners.push(owner);
                        });
                        property.owners = owners;
                    }
                }
                if (p.zonings) {
                    let zonings = {};
                    zonings = [];
                    p.zonings.forEach(z => {
                        const zone = {};
                        zone.zoning = z.zoning;
                        zonings.push(zone);
                    });
                    property.zonings = zonings;
                }
                properties.push(property);
            });
            app.properties = properties;
        }
        if (this.currentUser.id === application.createdUserId) {
            if (application.applicant) {
                let applicants = {};
                applicants = [];
                application.applicant.forEach(a => {
                    const applicant = {};
                    applicant.clientVatNumber = a.clientVatNumber;
                    applicant.setRecipient = a.setRecipient;
                    applicant.fullName = a.fullName;
                    applicant.id = 0;
                    applicant.moduleId = a.moduleId;
                    applicant.name = a.name;
                    applicant.surname = a.surname;
                    applicant.telephone = a.telephone;
                    applicant.email = a.email;
                    applicant.passportNumber = a.passportNumber;
                    applicant.defaultCommunicationMethod = a.defaultCommunicationMethod;
                    applicant.postalAddress = a.postalAddress;
                    applicant.designation = a.designation;
                    applicant.organisation = a.organisation;
                    applicant.streetAddress = a.streetAddress;
                    applicant.homePhone = a.homePhone;
                    applicant.idNumber = a.idNumber;
                    applicant.organisationRegistrationNumber = a.organisationRegistrationNumber;
                    applicant.representative = a.representative;
                    applicant.fax = a.fax;
                    applicant.gender = a.gender;
                    applicant.maritalStatus = a.maritalStatus;
                    applicant.relativesFullName = a.relativesFullName;
                    applicant.relativesContactNumber = a.relativesContactNumber;
                    applicant.relativesAddress = a.relativesAddress;
                    applicant.employmentStatus = a.employmentStatus;
                    applicant.employersName = a.employersName;
                    applicant.employersContactNumber = a.employersContactNumber;
                    applicant.employersAddress = a.employersAddress;
                    applicant.cellphone = a.cellphone;
                    applicant.streetSuburb = a.streetSuburb;
                    applicant.streetCity = a.streetCity;
                    applicant.streetProvince = a.streetProvince;
                    applicant.streetCode = a.streetCode;
                    applicant.postalSuburb = a.postalSuburb;
                    applicant.postalCity = a.postalCity;
                    applicant.postalProvince = a.postalProvince;
                    applicant.postalCode = a.postalCode;
                    applicant.postalCountry = a.postalCountry;
                    applicant.streetCountry = a.streetCountry;
                    applicant.professionalBody = a.professionalBody;
                    applicant.professionalBodyRegNum = a.professionalBodyRegNum;
                    applicant.consolidatedGroup = a.consolidatedGroup;
                    applicant.emailField = a.emailField;
                    let groups = {};
                    groups = [];
                    a.groups.forEach(g => {
                        const group = {};
                        group.groupName = g.groupName;
                        group.groupType = g.groupType;
                        groups.push(group);
                    });
                    applicant.groups = groups;
                    /*      owner.groupsStringArray?: string[]; */
                    applicants.push(applicant);
                });
                app.applicant = applicants;
            }
        }
        if (this.currentUser.id === application.createdUserId) {
            if (application.applicantAgent) {
                let applicantAgents = {};
                applicantAgents = [];
                application.applicantAgent.forEach(a => {
                    const applicantAgent = {};
                    applicantAgent.clientVatNumber = a.clientVatNumber;
                    applicantAgent.setRecipient = a.setRecipient;
                    applicantAgent.fullName = a.fullName;
                    applicantAgent.id = 0;
                    applicantAgent.moduleId = a.moduleId;
                    applicantAgent.name = a.name;
                    applicantAgent.surname = a.surname;
                    applicantAgent.telephone = a.telephone;
                    applicantAgent.email = a.email;
                    applicantAgent.passportNumber = a.passportNumber;
                    applicantAgent.defaultCommunicationMethod = a.defaultCommunicationMethod;
                    applicantAgent.postalAddress = a.postalAddress;
                    applicantAgent.designation = a.designation;
                    applicantAgent.organisation = a.organisation;
                    applicantAgent.streetAddress = a.streetAddress;
                    applicantAgent.homePhone = a.homePhone;
                    applicantAgent.idNumber = a.idNumber;
                    applicantAgent.organisationRegistrationNumber = a.organisationRegistrationNumber;
                    applicantAgent.representative = a.representative;
                    applicantAgent.fax = a.fax;
                    applicantAgent.gender = a.gender;
                    applicantAgent.maritalStatus = a.maritalStatus;
                    applicantAgent.relativesFullName = a.relativesFullName;
                    applicantAgent.relativesContactNumber = a.relativesContactNumber;
                    applicantAgent.relativesAddress = a.relativesAddress;
                    applicantAgent.employmentStatus = a.employmentStatus;
                    applicantAgent.employersName = a.employersName;
                    applicantAgent.employersContactNumber = a.employersContactNumber;
                    applicantAgent.employersAddress = a.employersAddress;
                    applicantAgent.cellphone = a.cellphone;
                    applicantAgent.streetSuburb = a.streetSuburb;
                    applicantAgent.streetCity = a.streetCity;
                    applicantAgent.streetProvince = a.streetProvince;
                    applicantAgent.streetCode = a.streetCode;
                    applicantAgent.postalSuburb = a.postalSuburb;
                    applicantAgent.postalCity = a.postalCity;
                    applicantAgent.postalProvince = a.postalProvince;
                    applicantAgent.postalCode = a.postalCode;
                    applicantAgent.postalCountry = a.postalCountry;
                    applicantAgent.streetCountry = a.streetCountry;
                    applicantAgent.professionalBody = a.professionalBody;
                    applicantAgent.professionalBodyRegNum = a.professionalBodyRegNum;
                    applicantAgent.consolidatedGroup = a.consolidatedGroup;
                    applicantAgent.emailField = a.emailField;
                    let groups = {};
                    groups = [];
                    a.groups.forEach(g => {
                        const group = {};
                        group.groupName = g.groupName;
                        group.groupType = g.groupType;
                        groups.push(group);
                    });
                    applicantAgent.groups = groups;
                    /*      owner.groupsStringArray?: string[]; */
                    applicantAgents.push(applicantAgent);
                });
                app.applicantAgent = applicantAgents;
            }
        }
        return app;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: MapTools },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: UserInformationService },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esriMap", { static: true },] }]
    };
};
CreateApplicationLocationTpamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-tpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateApplicationLocationTpamsComponent);
export { CreateApplicationLocationTpamsComponent };
